import type { GitArtifactPayloadAction } from "git/store/types";
import type { GenerateCDApiKeyResponse } from "../requests/generateCDApiKeyRequest";
import { call, put } from "redux-saga/effects";
import generateCDApiKeyRequest from "../requests/generateCDApiKeyRequest";
import { validateResponse } from "sagas/ErrorSagas";
import { gitArtifactActions } from "git/store/gitArtifactSlice";
import log from "loglevel";
import { captureException } from "@sentry/react";

export function* generateCDApiKeySaga(action: GitArtifactPayloadAction) {
  const { artifactDef } = action.payload;

  let response: GenerateCDApiKeyResponse | undefined;

  try {
    response = yield call(generateCDApiKeyRequest, artifactDef.baseArtifactId);
    const isValidResponse: boolean = yield validateResponse(response);

    if (response && isValidResponse) {
      yield put(
        gitArtifactActions.generateCDApiKeySuccess({
          artifactDef,
          responseData: response.data,
        }),
      );
    }
  } catch (e) {
    if (response && response.responseMeta.error) {
      const { error } = response.responseMeta;

      yield put(
        gitArtifactActions.generateCDApiKeyError({ artifactDef, error }),
      );
    } else {
      log.error(e);
      captureException(e);
    }
  }
}
